import _ from 'lodash';
import clsx from 'clsx';

import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  passcode: string;
  maxLength: number;
}

export default class PasscodeBubbles extends PureBaseComponent<Props> {
  render() {
    const { passcode, maxLength } = this.props;
    return (
      <div className="PasscodeBubbles">
        {_.times(maxLength, (i) => (
          <div
            key={i}
            className={clsx('PasscodeBubbles-bubble', {
              'PasscodeBubbles-bubble--filled': i <= passcode.length - 1,
            })}
          />
        ))}
      </div>
    );
  }
}
